import {
  container,
//cardTitle,
//whiteColor,
//grayColor,
  ts_main
} from "assets/jss/material-dashboard-pro-react.jsx";

const HistoryListStyle = theme => ({
  container: {
    ...container,
    backgroundColor: "#FFFFFF",
    zIndex: "4",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "0px",
      paddingBottom: "0px"
    }
  },
  labelHeader: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "1.7rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#FFDD00",
    textAlign        : "center",
  },
  label1: {
    fontSize     : "1rem",
    fontFamily   : '"Helvetica"',
    fontWeight   : "300",
    color        : "#303030",
    textAlign    : "left",
    "vertical-align":"middle",
  },
  logo: {
    margin: "1rem 0",
    "& img": {
      width: "25%",
      display: "block",
      margin: "auto"
    },
    "& span": {
      width: "100px",
      height: "1px",
      borderBottom: "3px solid " + ts_main[3],
      display: "block",
      margin: "1rem auto"
    }
  },
  listItembutton:{
    display: 'inline-block',
    padding:0,
    minHeight: 0,
    minWidth: 0,
    marginTop        : 2,
    marginBottom     : 2,
    textTransform    : 'none',
    //color            : "#35B6B4",
    color            : "#303030",
  },
  listItem_date: {
    marginTop        : 2,
    marginBottom     : 2,
    fontSize         : "0.8rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "100",
    color            : "#8D9A9E",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  listItem_TM: {
    marginTop        : 2,
    marginBottom     : 2,
    fontSize         : "0.8rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "100",
    color            : "#8D9A9E",
    textAlign        : "right",
    "vertical-align" : "middle",
  },
  listItem_fullName: {
    marginTop        : 2,
    marginBottom     : 2,
    fontSize         : "1.0rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "bold",
    color            : "#303030",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  listItem_amount: {
    marginTop        : 2,
    marginBottom     : 2,
    fontSize         : "1.0rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "bold",
    color            : "#303030",
    textAlign        : "right",
    "vertical-align" : "middle",
  },
  listItem_currency: {
    marginTop        : 0,
    marginBottom     : 0,
    fontSize         : "0.9rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "normal",
    color            : "#303030",
    textAlign        : "right",
    "vertical-align" : "middle",
  },

  popup_label_header: {
    marginLeft       : 50,
    marginRight      : 50,
    fontSize         : "0.8rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "200",
    color            : "#303030",
    textAlign        : "center",
    "vertical-align" : "middle",
  },
  popup_label_close: {
    marginLeft       : 50,
    marginRight      : 50,
    fontSize         : "0.8rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "200",
    color            : "#303030",
    textAlign        : "center",
    "vertical-align" : "middle",
  },
  popup_label_normal_action: {
    marginLeft       : 50,
    marginRight      : 50,
    fontSize         : "1.0rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "200",
    color            : "#35B6B4",
    textAlign        : "center",
    "vertical-align" : "middle",
  },
  popup_label_cancel_action: {
    marginLeft       : 50,
    marginRight      : 50,
    fontSize         : "1.0rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "200",
    color            : "#ff3333",
    textAlign        : "center",
    "vertical-align" : "middle",
  },

  History_nohistory_lbl1: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "1.2rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "bold",
    color            : "#35B6B4",
    textAlign        : "center",
    "vertical-align" : "middle",
  },
  History_nohistory_lbl2: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "1.0rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "center",
    "vertical-align" : "middle",
  },
  popupOkButton: {
    textTransform   : "none",
    backgroundColor : "#FFDD00",
    'border-radius' : "10px"
  },

  backButton: {
    fontSize         : "0.9rem",
    textTransform    : "none",
    marginTop        : 20,
    marginBottom     : 20,
    color            : "#0000ff",
    backgroundColor  : "rgba(255, 255, 255, 1.0)",
    width            : "100%",
    'border-radius'  : "25px",
    "&:hover"        : { fontWeight:"600", color:"#0000ff !important", background: "rgba(255, 255, 255, 1.0) !important"},
    "&:focus"        : { fontWeight:"600", color:"#0000ff !important", background: "rgba(255, 255, 255, 1.0) !important"},
  },

  //----------
  //PleaseWait
  //----------
  pleaseWait: {
    marginTop        : 50,
    marginBottom     : 0,
    fontSize         : "1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "center",
    "vertical-align" : "middle",
    display          : "flex",
    alignItems       : "center",
    justifyContent   : "center",
  },
});

export default HistoryListStyle;
